export class BranchShowcaseMiniEntity {
    id?: number;
    order?: number;
    showcaseId?: number;
    branchId?: number;
    branchName?: string | null;
    branchServiceId?: number;
    branchServiceName?: string | null;
}

